import React, { useState, useCallback, useRef } from 'react'

import {
  IconButton,
  ViewIcon,
  BodyText,
  HideIcon,
  LoadingSpinner,
} from '@paypalcorp/pp-react'
import ReactTooltip from 'react-tooltip'
import { CopyToClipboardButtonBanner } from '../copy-to-clipboard-button-banner'
import { recordDynamicEvent } from '../analytics/utils/record-dynamic-event'

import TextTwoLines from '../text-two-lines'
import apiFactory from '../../../utils/api-factory'

export const ToggleHiddenSecret = ({
  clientSecret,
  clientId,
  analitycsOrigen,
}) => {
  const BLUE_ICON_COLOR = '#0070ba'
  const GREY_ICON_COLOR = '#545d68'

  const [isHidden, setIsHidden] = useState(true)
  const [isLoadingClientSecret, setIsLoadingClientSecret] = useState(false)
  const [currentClientSecret, setClientSecret] = useState(clientSecret)
  const copyRef = useRef(null)

  const loadClientSecret = useCallback(
    async ({ target }) => {
      setIsLoadingClientSecret(true)
      const appCredential = await apiFactory.loadAppsCredentialUsingClientId({
        clientId,
      })

      if (target.name === 'copy-to-clipboard-banner') {
        copyRef.current.style.color = GREY_ICON_COLOR
      }

      setIsLoadingClientSecret(false)
      setClientSecret(appCredential.credentials.client_secret)

      return appCredential.credentials.client_secret
    },
    [clientId],
  )
  const handleShowClicks = async (event) => {
    recordDynamicEvent(
      `${analitycsOrigen},click,${
        isHidden ? 'Show' : 'Hide'
      } secret: ${clientId}`,
    )
    if (!currentClientSecret) await loadClientSecret(event)
    setIsHidden(!isHidden)
  }

  return (
    <>
      <div className="secret-container">
        {isLoadingClientSecret && <LoadingSpinner className="secret-spinner" />}
        {isHidden ? (
          <div
            className={`secret-wrapper ${
              isLoadingClientSecret ? 'loading-secret' : ''
            }`}
          >
            <BodyText style={{ paddingRight: '10px' }} id="secret-value">
              {'••••••••••••••••'}
            </BodyText>
            <IconButton
              style={{ padding: '0px', marginRight: '10px' }}
              data-for="viewHide"
              data-tip={isHidden ? 'Show' : 'Hide'}
              size="xs"
              buttonType="tertiary"
              svgIconComponent={isHidden ? ViewIcon : HideIcon}
              onClick={handleShowClicks}
              disabled={isLoadingClientSecret}
              onMouseOver={({ target }) =>
                (target.style.color = BLUE_ICON_COLOR)
              }
              onMouseOut={({ target }) =>
                (target.style.color = GREY_ICON_COLOR)
              }
            />
            <ReactTooltip
              className="dev_dash__tool-tip"
              id="viewHide"
              place="top"
              type="light"
              effect="solid"
            />
            <CopyToClipboardButtonBanner
              infoToCopy={currentClientSecret}
              analitycsOrigen={analitycsOrigen}
              onCopyClick={async (event) => {
                if (!currentClientSecret) await loadClientSecret(event)
              }}
              isDisabled={isLoadingClientSecret}
              props={{ ref: copyRef }}
            />
          </div>
        ) : (
          <TextTwoLines
            text={currentClientSecret}
            icon={
              <>
                <IconButton
                  style={{
                    padding: '0px',
                    marginRight: '10px',
                  }}
                  data-for="viewHide"
                  data-tip={isHidden ? 'Show' : 'Hide'}
                  size="xs"
                  buttonType="tertiary"
                  svgIconComponent={isHidden ? ViewIcon : HideIcon}
                  onClick={handleShowClicks}
                  onMouseOver={({ target }) =>
                    (target.style.color = BLUE_ICON_COLOR)
                  }
                  onMouseOut={({ target }) =>
                    (target.style.color = GREY_ICON_COLOR)
                  }
                />
                <ReactTooltip
                  className="dev_dash__tool-tip"
                  id="viewHide"
                  place="top"
                  type="light"
                  effect="solid"
                />
                <CopyToClipboardButtonBanner
                  infoToCopy={currentClientSecret}
                  analitycsOrigen={analitycsOrigen}
                />
              </>
            }
          />
        )}
      </div>
    </>
  )
}

export default ToggleHiddenSecret
